import "./styles.scss";

export const WidgetsContainer = ({ children }) => {
  return <div className="Widgets d-flex">{children}</div>;
};
